import React, { Component } from 'react';
import PropTypes from 'prop-types';

class InformationBlock extends Component {
  render() {
    const {
      text
    } = this.props;

    return (
      <div className="information-block">
        <div className="information-icon">
          <i className="fa fa-exclamation-circle" />
        </div>
        <div className="information-text">{text}</div>
      </div>
    )
  }
}

InformationBlock.propTypes = {
  text: PropTypes.string,
};

export default InformationBlock



// WEBPACK FOOTER //
// ./src/components/InformationBlock/index.js